import React from 'react';
import { format } from 'date-fns';
import { zhCN } from 'date-fns/locale';
import { useCurrentTime } from '../../hooks/useCurrentTime';
import { TimeDisplayProps } from '../../types';
import styles from '../../styles/components/ui/time-display.module.css';

const TimeDisplay: React.FC<TimeDisplayProps> = ({ 
  format: timeFormat = 'yyyy年MM月dd日 HH:mm:ss',
  updateInterval = 1000,
  className 
}) => {
  const currentTime = useCurrentTime(updateInterval);

  const formatTime = (date: Date): string => {
    try {
      return format(date, timeFormat, { locale: zhCN });
    } catch (error) {
      console.error('时间格式化失败:', error);
      return format(date, 'yyyy年MM月dd日 HH:mm:ss', { locale: zhCN });
    }
  };

  return (
    <div className={`${styles.timeDisplay} ${className || ''}`}>
      {formatTime(currentTime)}
    </div>
  );
};

export default TimeDisplay;